import { render, staticRenderFns } from "./Inscripcionrestx-add.vue?vue&type=template&id=1bce77b2"
import script from "./Inscripcionrestx-add.vue?vue&type=script&lang=js"
export * from "./Inscripcionrestx-add.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports